module.exports = __webpack_public_path__ + "static/media/trending_soon_hero_tablet.c66b9af5.png";